var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "80%",
        "close-on-press-escape": false,
        "custom-class": "layout-dialog",
        title: "不具合No選択",
        top: "5vh",
        visible: _vm.dialogVisible,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("vab-table", {
        ref: "table",
        attrs: {
          "api-url": "/api/mprbnop/foundData",
          columns: _vm.columns,
          "custom-config": false,
          "init-params": {
            inlstbr1cd: _vm.actionRow.inspectionList1Cd,
            inlstbr2cd: _vm.actionRow.inspectionList2Cd,
            inlstbr3cd: _vm.actionRow.inspectionList3Cd,
          },
        },
        on: { "selection-change": _vm.setSelectRows },
        scopedSlots: _vm._u([
          {
            key: "criterion",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("p", [_vm._v(_vm._s(row.prbjdgstd1))]),
                _c("p", [_vm._v(_vm._s(row.prbjdgstd2))]),
                _c("p", [_vm._v(_vm._s(row.prbjdgstd3))]),
                _c("p", [_vm._v(_vm._s(row.prbjdgstd4))]),
                _c("p", [_vm._v(_vm._s(row.prbjdgstd5))]),
                _c("p", [_vm._v(_vm._s(row.prbjdgstd6))]),
              ]
            },
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "mg12 flex_end" },
        [_c("vab-button", { attrs: { "btn-list": _vm.btnList } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }